// extracted by mini-css-extract-plugin
export default {"floatbutton":"floatingbutton_floatbutton__r0t9v"};